import SidePanel from '@ui/SidePanel/component'
import ElementMover from 'assets/core/js/module/elementMover'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import facets from 'assets/core/js/page/product/search/facets'

import type { SidePanelConfig } from '@ui/SidePanel/component'

export default function (): void {
  const searchEl = document.getElementById('search-availability-form')

  if (!searchEl) {
    return
  }

  const searchSubmitEl = searchEl.querySelector<HTMLButtonElement>('[type="submit"]')

  const filtersEl = document.getElementById('filter-offers')
  const filtersSubmitEl = document.getElementById('filter_offers_filter')

  let activeTabEl: HTMLElement | null | undefined
  let activeContentEl: HTMLElement | null | undefined
  let activeBottomEl: HTMLElement | null | undefined

  if (filtersEl || searchSubmitEl) {
    const sidePanelConfig: SidePanelConfig = {
      onOpen: function (sidePanel) {
        ElementMover.move(
          'search',
          searchEl,
          sidePanel.getElement()?.querySelector('.side-panel__content .content__block[data-content="search"]') as Element
        )

        if (filtersEl) {
          ElementMover.move(
            'filters',
            filtersEl,
            sidePanel.getElement()?.querySelector('.side-panel__content .content__block[data-content="filters"]') as Element
          )
        }

        if (searchSubmitEl) {
          ElementMover.move(
            'search-submit',
            searchSubmitEl,
            sidePanel.getElement()?.querySelector('.side-panel__bottom .actions__block[data-content="search"]') as Element
          )
        }

        if (filtersSubmitEl) {
          ElementMover.move(
            'filters-submit',
            filtersSubmitEl,
            sidePanel.getElement()?.querySelector('.side-panel__bottom .actions__block[data-content="filters"]') as Element
          )
        }
      },
      onClose: function () {
        if (activeTabEl) {
          const event = activeTabEl.getAttribute('data-target') === 'search' ? 'search' : 'filter'
          document.body.dispatchEvent(new CustomEvent(`search-page.${event}.modal.closed`))

          activeTabEl.classList.remove('tab__item--selected')
          activeContentEl?.classList.remove('visible')
          activeBottomEl?.classList.remove('visible')
          activeTabEl = null
        }

        // reverse order of moved elements so we don't have missing nodes when repositionning elements
        if (filtersSubmitEl) {
          ElementMover.restore('filters-submit')
        }

        ElementMover.restore('search-submit')

        if (filtersEl) {
          ElementMover.restore('filters')
        }

        ElementMover.restore('search')
      },
    }

    const sidePanelEl = document.getElementById('filters-side-panel')

    if (!sidePanelEl) {
      return
    }

    const sidePanel = SidePanel(sidePanelEl, sidePanelConfig)

    if (!sidePanel) {
      return
    }

    ElementPropertiesManager.addProperty(sidePanelEl, 'sidePanel', sidePanel)
    ;['opened', 'closed'].forEach((state) => {
      sidePanel?.getElement()?.addEventListener(`sidePanel.${state}`, () => {
        document.body.dispatchEvent(new CustomEvent(`product-page.filter.modal.${state}`))
      })
    })

    activeTabEl = sidePanel.getElement()?.querySelector<HTMLElement>('.tab__item--selected')
    activeContentEl = sidePanel.getElement()?.querySelector<HTMLElement>('.content__block.visible')
    activeBottomEl = sidePanel.getElement()?.querySelector<HTMLElement>('.actions__block.visible')

    sidePanel
      ?.getElement()
      ?.querySelectorAll('.tab__item')
      .forEach(function (el) {
        el.addEventListener('click', function (this: HTMLElement) {
          if (activeTabEl) {
            activeTabEl.classList.remove('tab__item--selected')
            activeContentEl?.classList.remove('visible')
            activeBottomEl?.classList.remove('visible')
          }

          const target = this.getAttribute('data-target') as string

          if (!activeTabEl || activeTabEl.getAttribute('data-target') !== target) {
            const event = target === 'search' ? 'search' : 'filter'
            document.body.dispatchEvent(new CustomEvent(`search-page.${event}.modal.opened`))
          }

          this.classList.add('tab__item--selected')

          // eslint-disable-next-line @typescript-eslint/no-this-alias
          activeTabEl = this
          activeContentEl = sidePanel.getElement()?.querySelector<HTMLElement>(`.content__block[data-content="${target}"]`)
          activeBottomEl = sidePanel.getElement()?.querySelector<HTMLElement>(`.actions__block[data-content="${target}"]`)

          activeTabEl.classList.add('tab__item--selected')
          activeContentEl?.classList.add('visible')
          activeBottomEl?.classList.add('visible')
        })
      })

    const sortResultsFn = function (e: MouseEvent): void {
      e.preventDefault()
      sidePanel.close()
      void (async () => {
        await facets.sortAccommodations()
      })()
    }

    document.getElementById('find')?.addEventListener('click', sortResultsFn)
    document.getElementById('filter_offers_filter')?.addEventListener('click', sortResultsFn)
  }
}
